import {ReactElement} from 'react';
import PublicUser from 'public/interfaces/PublicUser';
import HeaderView from './HeaderView';

type Props = {
  publicUser: PublicUser | null;
};

function Header({publicUser}: Props): ReactElement {
  return <HeaderView publicUser={publicUser} />;
}

export default Header;
